import { Dispatch, SetStateAction, createContext } from 'react';
import { IGetUserBlob, ISearchUser } from '../../model';

export const LoggedUserContext = createContext<{
    loggedUser: IGetUserBlob | undefined;
    setLoggedUser: Dispatch<SetStateAction<IGetUserBlob | undefined>>;
}>({ loggedUser: undefined, setLoggedUser: () => {} });
